const getValueAddPercent = (value, percent) => Number(value) + (Number(value) / 100) * percent;

export default getValueAddPercent;
